const e = {
  name: "LightningFilled",
  dimensions: { width: 24, height: 24 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9762 1.2169C11.0799 0.750122 10.8387 0.275222 10.4005 0.0836955C9.96241 -0.107831 9.44999 0.0376174 9.17781 0.430765L0.17781 13.4308C-0.0339042 13.7366 -0.0583987 14.1346 0.114223 14.4641C0.286845 14.7935 0.628058 15 1 15H6.75339L5.02382 22.783C4.92009 23.2498 5.16132 23.7247 5.59946 23.9163C6.0376 24.1078 6.55002 23.9623 6.82219 23.5692L15.8222 10.5692C16.0339 10.2634 16.0584 9.86533 15.8858 9.53587C15.7132 9.20641 15.3719 8.99997 15 8.99997H9.24662L10.9762 1.2169Z" fill="currentColor"/>
    `
};
export {
  e as LightningFilled
};
